import { forwardRef, createElement } from 'react';

function IconLedgerCardCustomerReminder(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M10.5 11.5c1.69 0 3.093.4 4.212 1.198a4.49 4.49 0 00-.83 1.255C12.996 13.307 11.875 13 10.5 13c-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007h6.506L12.5 22H5.993a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm8.725 9.474A1.259 1.259 0 0118 22c-.605 0-1.11-.44-1.225-1.026h2.45zM18 12c.456 0 .841.392.961.927A3 3 0 0121 15.769v2.898l.835.642a.5.5 0 01-.213.888l-.092.008h-7.06a.5.5 0 01-.305-.896l.835-.642v-2.898c0-1.32.854-2.442 2.04-2.843.119-.534.504-.926.96-.926zM10.5 2C12.433 2 14 3.903 14 6.25s-1.567 4.25-3.5 4.25S7 8.597 7 6.25 8.567 2 10.5 2zm0 1.5c-1.033 0-2 1.174-2 2.75S9.467 9 10.5 9s2-1.174 2-2.75-.967-2.75-2-2.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var LedgerCardCustomerReminder = /*#__PURE__*/forwardRef(IconLedgerCardCustomerReminder);

export default LedgerCardCustomerReminder;
//# sourceMappingURL=LedgerCardCustomerReminder.js.map
